import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '../StyledTypography';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import styles from './LinkedItemsList.module.css';

/**
 * LinkedItemsList - Reusable molecule that displays a list of linked items
 * (forms or subforms) with numbered cards and navigation links.
 *
 * @param {Array} items - Array of objects with { id, name/label }
 * @param {string} titleKey - Translation key for the section title
 * @param {string} emptyKey - Translation key for the empty state
 * @param {string} linkPrefix - URL path segment (e.g. "forms", "subforms")
 * @param {string} persona - Current persona for link building (e.g. "admin")
 */
const LinkedItemsList = ({
  items = [],
  titleKey,
  emptyKey,
  linkPrefix,
  persona = 'admin',
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography variant="title2" className={styles.title}>
        {t(titleKey)}
      </Typography>

      {items.length === 0 ? (
        <Typography variant="body2" className={styles.emptyText}>
          {t(emptyKey)}
        </Typography>
      ) : (
        <div className={styles.list}>
          {items.map((item, index) => (
            <Link
              key={item.id}
              to={`/${persona}/${linkPrefix}/details/${item.id}`}
              className={styles.cardLink}
            >
              <Card interactive className={styles.card}>
                <CardContent className={styles.cardContent}>
                  <span className={styles.order}>{index + 1}</span>
                  <Typography variant="body2" className={styles.name}>
                    {item.label || item.name}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default LinkedItemsList;
